module.exports = __webpack_public_path__ + "img/logoPGD.a3f17638.png";